module.exports = __webpack_public_path__ + "img/internal-currency.3cc71c28.png";